<template>
    <footer class="footer mt-auto">
      <div class="container text-center">
        <p>&copy; {{ new Date().getFullYear() }} Topsail Software Inc.</p>
        <div class="footer-links">
             <a href="mailto:contact@topsailsoftware.ca">Contact Us</a>
        </div>
      </div>
    </footer>
  </template>
  
  <script>
    export default {
      name: 'FooterComponent'
    }
  </script>
  
  <style scoped>
    .footer {
        padding: 2rem 0;
        border-top: 1px solid var(--surface-dark);
        color: var(--text-muted);
        font-size: 0.9rem;
        background-color: var(--bg-darker);
    }
    
    .footer-links {
        margin-top: 0.5rem;
    }

    .footer-links a {
        color: var(--text-muted);
        margin: 0 10px;
        text-decoration: none;
        transition: color 0.3s ease;
    }
    
    .footer-links a:hover {
        color: var(--primary);
    }
  </style>